import { create } from "zustand";

export const useProductStore = create((set) => ({
  productPrice: 0,
  setProductPrice: (price) => set((state) => ({ productPrice: price })),
}));
